/**
 * Environment Configuration Manager
 * 환경별 설정을 관리하고 제공합니다
 */

interface Config {
  apiUrl: string;
  useMockApi: boolean;
  environment: 'development' | 'staging' | 'production';
  debug: boolean;
  kubeArmorNamespace: string;
}

const getConfig = (): Config => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const useMockApi = process.env.REACT_APP_USE_MOCK === 'true';
  const environment = (process.env.REACT_APP_ENV as 'development' | 'staging' | 'production') || 'development';
  const debug = process.env.REACT_APP_DEBUG === 'true';
  const kubeArmorNamespace = process.env.REACT_APP_KUBEARMOR_NAMESPACE || 'kubearmor';

  return {
    apiUrl,
    useMockApi,
    environment,
    debug,
    kubeArmorNamespace,
  };
};

const config = getConfig();

// 개발 환경에서 설정 로깅
if (config.debug) {
  console.log('🔧 Configuration loaded:', {
    environment: config.environment,
    apiUrl: config.apiUrl,
    useMockApi: config.useMockApi,
    kubeArmorNamespace: config.kubeArmorNamespace,
  });
}

export default config;
export type { Config };
